import axios, { AxiosRequestConfig } from "axios";

const getWinners = async (date: string): Promise<any> => {
  try {
    // date = "20210930";
    const config: AxiosRequestConfig = {
      method: "GET",
      // Lokalno (development)
      // url: `http://localhost:6002/api/ultra/politehnika/winners`,
      
      // Produkcija
      url: `https://politehnika-back.firebird.rs/api/ultra/politehnika/winners`,
      headers: {
        "Content-Type": "application/json",
      },
      params: {
        date,
      },
    };

    const response = await axios(config);
    const { data } = response;
    const { code } = data;

    if (code !== 200) {
      return [];
    }

    return data.data;
  } catch (error) {
    return [];
  }
};

export default getWinners;
